import { HostType } from './types';
import { AccessibilityNamespace, BreakpointsNamespace, RefComponentsNamespace, InfoNamespace, ComponentsNamespace, ApplicationManagerNamespace, CustomElementNamespace, InputsNamespace, ExperimentsNamespace, AuthNamespace, ExternalPanels, } from './namespaces';
export const COMMON_NAMESPACES = [
    AccessibilityNamespace,
    RefComponentsNamespace,
    InfoNamespace,
    ComponentsNamespace,
    ApplicationManagerNamespace,
    CustomElementNamespace,
    InputsNamespace,
    ExperimentsNamespace,
    AuthNamespace,
];
export const CLASSIC_NAMESPACES = [];
export const EDITORX_NAMESPACES = [BreakpointsNamespace];
export const STUDIO_NAMESPACES = [...EDITORX_NAMESPACES, ExternalPanels];
function getPrivateApiNamespaces(hostType) {
    switch (hostType) {
        case HostType.Classic:
            return [...COMMON_NAMESPACES, ...CLASSIC_NAMESPACES];
        case HostType.Editorx:
            return [...COMMON_NAMESPACES, ...EDITORX_NAMESPACES];
        case HostType.Studio:
            return [...COMMON_NAMESPACES, ...STUDIO_NAMESPACES];
        default:
            throw new Error(`Unsupported host type: "${hostType}"`);
    }
}
export function createPrivateAPI(hostType, ps) {
    const namespaces = getPrivateApiNamespaces(hostType);
    return namespaces.reduce((api, factory) => {
        return {
            ...api,
            [factory.namespace]: new factory(hostType, ps),
        };
    }, {});
}
//# sourceMappingURL=createPrivateAPI.js.map